import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-black" data-id="element-191">
      <div className="max-w-3xl mx-auto px-4" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-193">
          {/* Subtle green glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-md h-32 bg-green-500/10 blur-[60px] pointer-events-none" data-id="element-194" />

          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 15
        }} className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-green-500/10 border border-green-500/20 mb-6 relative z-10" data-id="element-195">
            <ShieldCheckIcon className="w-12 h-12 text-green-500" data-id="element-196" />
          </motion.div>

          <h2 className="text-2xl md:text-4xl font-black uppercase tracking-tight text-white mb-6 relative z-10" data-id="element-197">
            7 DÍAS DE GARANTÍA TOTAL
          </h2>

          <p className="text-gray-400 text-lg leading-relaxed relative z-10" data-id="element-198">
            Si dentro de los primeros 7 días tenés cualquier inconveniente de
            acceso al material, problemas técnicos o dificultades para
            visualizar el contenido, te ayudamos a resolverlo de inmediato o te
            devolvemos el 100% de tu dinero. <br data-id="element-199" />
            <br data-id="element-200" />
            <span className="text-white font-medium" data-id="element-201">
              Tu compra está completamente protegida.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}